import { render, staticRenderFns } from "./ChatHistoryItem.vue?vue&type=template&id=13a10205"
import script from "./ChatHistoryItem.vue?vue&type=script&lang=js"
export * from "./ChatHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryItem.vue?vue&type=style&index=0&id=13a10205&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports